import { clampTo, resolveImageSize } from '../../tools';
import type { alibabaModelConfig } from '../types';

export const zimageConfigs: Record<string, alibabaModelConfig> = {
    'z-image-turbo': {
        // https://bailian.console.aliyun.com/cn-beijing?spm=5176.12818093_47.overview_recent.3.e8292cc9QWCSs5&tab=api#/api/?type=model&url=3002354
        apiPath: '/api/v1/services/aigc/multimodal-generation/generation',
        pollApiPath: '',
        statusMapping: {
            taskIdPath: '',
            createErrorPath: 'message',
            statePath: '',
            success: [],
            failed: [],
            processing: [],
            imageUrlPath: 'output.choices[0].message.content[0].image',
            errorPath: '',
        },
        synchronous: true,
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, aspectRatio, providerOptions } = params;
            return {
                model: 'z-image-turbo',
                input: {
                    messages: [
                        {
                            role: 'user',
                            content: [
                                {
                                    text: prompt.slice(0, 800),
                                }
                            ]
                        }
                    ]
                },
                parameters: {
                    size: resolveImageSize(
                        clampTo(aspectRatio || '16:9', ['21:9', '9:21', '16:9', '9:16', '9:7', '7:9', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, '16:9'), 'z-image-turbo'),
                    seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
                    // 可选参数
                    prompt_extend: false,
                },
            };
        },
    },
};